var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    color: "#8E8E8E",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74927 10.0007C6.74927 11.7784 8.20455 13.2249 10.0013 13.2249C11.7899 13.2249 13.2452 11.7784 13.2452 10.0007C13.2452 8.21479 11.7899 6.76833 10.0013 6.76833C8.20455 6.76833 6.74927 8.21479 6.74927 10.0007ZM14.7818 5.03903C16.2046 6.13802 17.4159 7.7461 18.2859 9.75823C18.3509 9.91176 18.3509 10.0895 18.2859 10.235C16.546 14.2592 13.4485 16.6673 10.0013 16.6673H9.99317C6.55415 16.6673 3.45659 14.2592 1.71675 10.235C1.65171 10.0895 1.65171 9.91176 1.71675 9.75823C3.45659 5.73398 6.55415 3.33398 9.99317 3.33398H10.0013C11.7249 3.33398 13.359 3.93196 14.7818 5.03903ZM10.0023 12.011C11.1161 12.011 12.0267 11.1059 12.0267 9.99887C12.0267 8.88372 11.1161 7.97867 10.0023 7.97867C9.90472 7.97867 9.80716 7.98675 9.71773 8.00291C9.68521 8.8918 8.9535 9.60291 8.05106 9.60291H8.01041C7.98602 9.73221 7.96976 9.8615 7.96976 9.99887C7.96976 11.1059 8.88033 12.011 10.0023 12.011Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIc);
export default __webpack_public_path__ + "static/media/eye_ic.f778c0b2a752effa8b80e89851480f26.svg";
export { ForwardRef as ReactComponent };